import { CardComponentProps } from "@~/types/types";
import { SocialProofMessage } from "@JohnLewisPartnership/jl-design-system/dist/components/social-proof-message/SocialProofMessage";
import { useSocialProofMessages } from "@~/contexts/SocialProofMessagesContext/SocialProofMessagesContext";
import { useFeatureFlags } from "@~/flags/flags";

export function SocialProofMessaging({
  product,
}: Pick<CardComponentProps, "product">) {
  const { messages } = useSocialProofMessages();

  const flags = useFeatureFlags();

  const altSocialProofPositioningEnabled = Boolean(
    flags.altSocialProofEnabled?.value,
  );

  const getSocialProofMessage = () => {
    const productMessage = messages.filter(
      (data) => data.productId === product.aliases.pimProductId,
    );
    return productMessage.length > 0 ? productMessage[0]?.messages : null;
  };

  const message = getSocialProofMessage();
  const socialProofMessageExperiments = altSocialProofPositioningEnabled
    ? [
        {
          impressionId: null,
          experienceId: 12345,
          experienceName: "",
          variantLabel: "Experiment",
          component: null,
          parameters: { ffUIRestyled: "on" },
        },
      ]
    : undefined;

  if (!message) {
    return null;
  }
  return (
    <SocialProofMessage
      message={`${message[0]?.title}`}
      socialProofMessageExperiments={socialProofMessageExperiments}
    ></SocialProofMessage>
  );
}
